








import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { EPaymentMethod } from '@/helpers/enums';

@Component
export default class LabelDiscount extends Vue {
  @Prop()
  private readonly text!: string;

  private get labelDiscount() {
    return this.$t(`App.Checkout.Payment.discount.paymentsMethods.${EPaymentMethod.creditCard}`) || this.text;
  }
}
